import gql from "graphql-tag"

const START_SHIPPING_FEE_MODIFICATION = gql`
  mutation startModificationShippingFees($modificationId: ID!, $input: InputOrderModificationShippingFeesStart!) {
    Order {
      startOrderModificationShippingFees(modificationId: $modificationId, input: $input) {
        status
      }
    }
  }
`

export default START_SHIPPING_FEE_MODIFICATION
